import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Browser } from '@capacitor/browser';
import { NavController } from '@ionic/angular';
import { switchMap, take } from 'rxjs';
import { AuthData, LoginReq } from 'src/app/api/contracts/auth';
import { AuthService } from 'src/app/auth/auth.service';
import { APP_CONFIG, AppConfig } from 'src/app/config/app-config';
import { AppEventsService } from 'src/app/services/app-events.service';
import { LanguageService } from 'src/app/services/language.service';
import { StorageKeys, StorageService } from 'src/app/services/storage.service';
import { LoaderController } from 'src/app/utils/loader-controller';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./../auth-common.scss', './login.component.scss'],
})
export class LoginComponent implements OnInit {
  public readonly loginForm: FormGroup<Record<keyof LoginReq, FormControl>>;
  public readonly loader = new LoaderController();

  public showWrongCredentialsMessage: boolean = false;

  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: AppConfig,
    private readonly navCtrl: NavController,
    private readonly storageService: StorageService,
    private readonly eventService: AppEventsService,
    private readonly authService: AuthService,
    private readonly languageService: LanguageService
  ) {
    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(this.appConfig.fieldValidation.email.pattern),
      ]),
      password: new FormControl('', [
        Validators.required,
        // Validators.minLength(this.appConfig.fieldValidation.password.minLength),
        Validators.maxLength(64),
        // Validators.pattern(this.appConfig.fieldValidation.password.pattern),
      ]),
    });

    this.loginForm.valueChanges.subscribe(() => {
      this.showWrongCredentialsMessage = false;
    });
  }

  ngOnInit() {
    return;
  }

  onForgotPasswordClick(): void {
    this.navCtrl.navigateForward('forgot-password');
  }

  onLoginButtonClick(): void {
    if (this.loader.isLoadingNow()) {
      return;
    }
    this.loader.enqueue();
    this.authService.login(this.loginForm.value as LoginReq).subscribe({
      next: (authData) => {
        this.eventService.afterLogin.next(authData);
        this.navCtrl.navigateRoot('store');
      },
      error: (err) => {
        this.showWrongCredentialsMessage = true;
        this.loader.dequeue();
      },
      complete: () => {
        this.loader.dequeue();
      },
    });
  }

  onDontHaveAccountClick(): void {
    this.navCtrl.navigateRoot('signup');
  }

  onOpenPolicyLink(): void {
    const currentLang = this.languageService.currentLang
      .pipe(take(1))
      .subscribe((currentLang) => {
        Browser.open({
          url: this.appConfig.privacyPolicyUrls[currentLang],
        });
      });
  }

  onOpenTermsOfUseLink(): void {
    this.navCtrl.navigateForward('terms-of-use');
  }

  onOpenImprintLink(): void {
    this.navCtrl.navigateForward('imprint');
  }
}
